module.exports = __webpack_public_path__ + "media/images/lb/390-d26e66d049b4c4f1557f85d7948978a9.svg";